import { BatchId } from '@/Domain/Batch'
import { XmlString } from './XmlString'

export class XmlOffer {
  private _batchId: BatchId
  private _xmlString: XmlString

  constructor (batchId: string, recordId: string, xmlString: string) {
    this._batchId = new BatchId(batchId, recordId)
    this._xmlString = new XmlString(xmlString)
  }

  batchId (): string {
    return this._batchId.batchId()
  }

  recordId (): string {
    return this._batchId.recordId()
  }

  xmlString (): string {
    return this._xmlString.name()
  }
}
